/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_TitleInputs */

const tr_landing_finalcta_title = /** @type {(inputs: Landing_Finalcta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaretiniz yeniden`)
};

const en_landing_finalcta_title = /** @type {(inputs: Landing_Finalcta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your e-commerce`)
};

const de_landing_finalcta_title = /** @type {(inputs: Landing_Finalcta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr E-Commerce soll wieder`)
};

const ru_landing_finalcta_title = /** @type {(inputs: Landing_Finalcta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пусть ваш онлайн-бизнес снова`)
};

/**
* | output |
* | --- |
* | "Make your e-commerce" |
*
* @param {Landing_Finalcta_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_title = /** @type {((inputs?: Landing_Finalcta_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_title(inputs)
	if (locale === "de") return de_landing_finalcta_title(inputs)
	if (locale === "ru") return ru_landing_finalcta_title(inputs)
	return tr_landing_finalcta_title(inputs)
});